import React from "react";
import { Button } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import { AntInput } from "../../../../components/atoms/AntField";
import { ResetPasswordSchema } from "../../../../system/helpers/validation";

const ResetPasswordForm: React.FC<any> = ({ onSubmit }) => {
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      repeatPassword: "",
    },
    validateOnBlur: false,
    validationSchema: ResetPasswordSchema,
    onSubmit: onSubmit,
  });

  const { values, submitCount, isValid, handleChange, handleBlur } = formik;

  const submitForm = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  return (
    <FormikProvider value={formik}>
      <form onSubmit={submitForm} className="forgot-password-form-container">
        <Field
          component={AntInput}
          name="email"
          type="email"
          placeholder="Email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          submitCount={submitCount}
        />
        <Field
          component={AntInput}
          name="password"
          type="password"
          placeholder="New password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          submitCount={submitCount}
        />
        <Field
          component={AntInput}
          name="repeatPassword"
          type="password"
          placeholder="Retype password"
          value={values.repeatPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          submitCount={submitCount}
        />
        <Button
          type="primary"
          htmlType="submit"
          disabled={!isValid}
          className="login-form-submit"
        >
          Reset my password
        </Button>
      </form>
    </FormikProvider>
  );
};

export default ResetPasswordForm;
